import { Component, Input, OnInit } from '@angular/core';
import { AppAlert } from '../../contracts/app-alert.interface';
import { LaravelErrorArray, LaravelResourceResponse } from '../../contracts/laravel-response.interface';

@Component({
  standalone: false,
  selector:    'app-server-response',
  templateUrl: './server-response.component.html',
})
export class ServerResponseComponent implements OnInit {
  @Input() localAlerts: Array<AppAlert> = [];
  @Input() response: LaravelResourceResponse;
  @Input() showOnErrors                 = [422];
  @Input() title: string;
  @Input() errors: LaravelErrorArray    = {};

  ngOnInit(): void {
  }

  public closeLocalResponse(): void {
    this.localAlerts = [];
  }

  public closeResponse(): void {
    this.response = null;
  }

  public clearErrors(): void {
    this.title  = null;
    this.errors = {};
  }

  public getKeys(obj: object): string[] {
    return Object.keys(obj);
  }


}
